export default {
  name: 'appNav'
}



// WEBPACK FOOTER //
// ./src/views/partials/app-nav/index.js